let config = {
	addons: [],

	dataDomain:
		typeof document === 'undefined'
			? ''
			: document.location.hostname !== 'velvetmitten.test'
				? ''
				: document.location.port === '' ||
					  document.location.port === '80'
					? 'http://data.velvetmitten.test:' + process.env.APP_PORT
					: 'http://data.velvetmitten.test:80',
};

export default config;
